/** Only ever appears on the preview address. The live shop never sees this. */
const isPreview = typeof window !== "undefined"
  && /preview\.emergentagent\.com$|^localhost$/.test(window.location.hostname);

export const PreviewBanner = () => {
  if (!isPreview) return null;
  return (
    <div
      className="sticky top-0 z-[60] flex items-center justify-center gap-2 bg-[#B3261E] px-3 py-1.5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-white"
      data-testid="preview-banner"
    >
      Preview — practice copy, not the real shop. Nothing here reaches customers.
    </div>
  );
};
